
// import { getNotifications } from "../../utils/services/notification/notificationService";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getCourseRoi, getRoi } from "../../utils/services/roi/roiServices";

export const getRoiAnalytics = createAsyncThunk(
  "/admin/getRoi",
  async (params, thunkAPI) => {
      // const month=params?.month;
      // const year=params?.year;
      // const searchKey=params?.searchKey;
      // const pageNo=params?.page;
      // const limit=params?.pageSize;

      const {
        pageNo,
        pageLimit,
        searchKey,
      } = thunkAPI.getState().roi;
     console.log("IN ACTION CRETOR:", pageNo, pageLimit, searchKey );
     const payload = {
      page: pageNo + 1,
      limit: pageLimit,
      search: searchKey,
      month: params?.month,
      year: params?.year
    };

    const { data, error } = await getRoi(payload);
    if (error) {
        return thunkAPI.rejectWithValue(response?.error);
    }
    return data;
  }
);

export const getCourseAnalytics = createAsyncThunk(
    "/admin/getCourseAnalytics",
    async (params, thunkAPI) => {
       const month=params?.month;
       const year=params?.year;
      const { data, error } = await getCourseRoi({month,year});
      if (error) {
       
          return thunkAPI.rejectWithValue(response?.error);
      }
     
      return data;
    }
  );



const initialState = {
  pageNo:0,
  pageLimit:10,
  searchKey:"",
  roiAnalyticsData: null,
  courseAnalyticsData: null,
  error: null,
  loading: false,
};

const roiSlice = createSlice({
  name: "roi",
  initialState,
  reducers: {
    resetPaginationModel(state, action) {
      state.pageNo = 0;
      state.pageLimit = 10;
    },
    setPaginationModel(state, action) {
      console.log("Setting val:", action);
      state.pageNo = action.payload.page;
      state.pageLimit = action.payload.pageSize;
    },
    setSearchKey(state, action) {
      console.log("Setting val:", action);
      state.searchKey = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getRoiAnalytics.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getRoiAnalytics.fulfilled, (state, action) => {
      state.loading = false;
      state.roiAnalyticsData = action?.payload;
    });
    builder.addCase(getRoiAnalytics.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(getCourseAnalytics.pending, (state) => {
        state.loading = true;
      });
      builder.addCase(getCourseAnalytics.fulfilled, (state, action) => {
        state.loading = false;
        state.courseAnalyticsData = action?.payload;
      });
      builder.addCase(getCourseAnalytics.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});


export const {
  resetPaginationModel,
  setPaginationModel,
  setSearchKey,
} = roiSlice.actions;
export default roiSlice.reducer;




// export default roiSlice.reducer;
